import { tsUtils } from '@neo-one/ts-utils';
export const hasArray = (_context, _node, type) => tsUtils.type_.hasArrayish(type);
export const isOnlyArray = (_context, _node, type) => tsUtils.type_.isOnlyArrayish(type);
export const isArray = (_context, _node, type) => tsUtils.type_.isArrayish(type);

//# sourceMappingURL=typeTests.js.map
